import { AppError } from '@/lib/error';

let logoutHandler: () => void;

export function setLogoutHandler(fn: () => void) {
  logoutHandler = fn;
}

export async function handleResponse<T>(
  response: Response,
  context: string,
  notFoundMessage: string,
): Promise<T> {
  if (response.status === 404) {
    throw new AppError('notFound', notFoundMessage);
  }

  if (response.status === 403) {
    logoutHandler?.();
    throw new AppError('forbidden', 'Você não tem permissão para realizar essa ação', {
      details: { root: ['Você não tem permissão para realizar essa ação'] },
    });
  }

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new AppError('internalError', `${context}: ${error?.message ?? response.statusText}`);
  }

  return response.json() as Promise<T>;
}
